import { bookingGetBooking } from '@actions/booking.action';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectTokenGetBooking } from '@selectors/booking.selector';
import { Observable, delay, mergeMap, of, take, withLatestFrom } from 'rxjs';

export const getInStateBookingDataGuard = (): Observable<boolean> => {
  const store = inject(Store);
  return store.select(selectTokenGetBooking).pipe(
    delay(0), //ensure the store has been updated
    take(1),
    withLatestFrom(store.select(selectTokenGetBooking)),
    mergeMap(([shouldGetBooking, shouldGetBookingLatest]: [boolean, boolean]): Observable<boolean> => {
      if (shouldGetBooking && shouldGetBookingLatest) {
        store.dispatch(bookingGetBooking({}));
      }
      return of(true);
    }),
  );
};